//**auto-generated don't edit this code**//
export enum SubjectPublishType {
	Off,
	Indefinitely,
	SchoolYear,
	MarkingPeriod,
	CustomDateRange,
}